import i18n from "i18next";
import { initReactI18next } from "react-i18next";
i18n.use(initReactI18next).init({
  resources: {
    "pt-BR": {
      translations: {
        feature1: {
          title: "Na sua viagem, <strong>ao seu lado.</strong>",
          item1:
            "Cobrimos suas <strong>necessidades médicas</strong> e também <strong>outros imprevistos</strong> que possam impactar sua experiência de viagem.",
          item2:
            "Oferecemos proteção em <strong>todo o mundo,</strong>, evitando custos elevados no exterior.",
          item3:
            "Com nosso seguro viagem, você garante proteção, economia e tranquilidade em cada etapa da sua viagem.",
        },
        feature2: {
          title:
            "Estamos ao seu lado para garantir uma viagem tranquila e segura",
          item1: "Assistência médica",
          item2: "Doenças preexistentes",
          item3: "Perda de bagagem",
          item4: "Medicamentos",
          item5: "Médico online 24hs",
          item6: "Cobertura mundial",
          item7: "Odontologia",
          item8: "Internações",
          infoText:
            "E muito mais, de acordo com o plano que melhor atende às suas necessidades",
          infoText2: "Nossos planos são feitos sob medida para a sua viagem.",
          btnLabel: "Cote e conheça os planos",
        },
        feature3: {
          title: "Asseguramos que você vai aproveitar ao máximo!",
          dropline:
            "Aproveite sua viagem com tranquilidade, estamos aqui para ajudar em qualquer imprevisto.",
          item1:
            "Contrate a Assist 365 e comece sua viagem com tranquilidade, estamos prontos para acompanhar você.",
          item2:
            "Se surgir algum imprevisto, nossa central de emergências  oferecerá orientação de acordo com as suas necessidades.",
          item3: "Siga aproveitando sem preocupações, estamos ao seu lado.",
          btnLabel: "Cote sua viagem agora!",
        },
        feature4: {
          title:
            "Se você viaja com frequência, temos o plano perfeito para você.",
          infoText:
            "Viagens ilimitadas durante todo o ano, com até 30, 60 ou 90 dias por viagem.",
          btnLabel: "Cote e conheça o plano multitrip",
        },
        feature5: {
          title: "Eleve sua experiência",
          dropline:
            "Amplie sua proteção com opções extras feitas para sua segurança e conforto",
          card1: {
            title: "Tecnologia protegida",
            content:
              "Cobertura para câmeras fotográficas, filmadoras, smartphones, tablets e computadores.",
          },
          card2: {
            title: "Cobertura para gravidez",
            content:
              "Para futuras mamães, cobertura até as 32 semanas de gestação, entre 19 e 45 anos.",
          },
          card3: {
            title: "Danos à bagagem",
            content:
              "Cobertura em caso de danos na parte externa da bagagem ou violação de cadeados.",
          },
          card4: {
            title: "Assistência para pets",
            content:
              "Para a saúde dos seus animais de estimação, cobertura para acidentes ou doenças não preexistentes.",
          },
          btnLabel: "Cote sua viagem agora",
        },
        paymentMethods: {
          title: "Pague no cartão, PIX ou Paypal",
          infoText: "Tem dúvidas sobre os métodos de pagamento?",
          linkText: "Visite as perguntas frequentes",
          btnLabel: "Cote sua viagem",
        },
        faqs: {
          title: "Tudo o que você precisa saber para viajar sem preocupações",
          ctaFaqs: "Ler outras perguntas frequentes",
          item1: {
            question: "O que é seguro viagem?",
            answer:
              "O seguro viagem é um serviço que oferece cobertura e suporte médico em caso de emergências durante sua viagem. Com a ASSIST 365, você terá proteção médica, repatriação sanitária, assistência jurídica, cobertura para perda de bagagem, entre muitos outros serviços essenciais para garantir sua tranquilidade enquanto viaja.",
          },
          item2: {
            question:
              "Qual é a diferença entre um seguro viagem e um seguro médico para viajar?",
            answer:
              "O seguro de viagem oferece uma cobertura abrangente que inclui benefícios médicos, assistência em caso de atraso de voos, extravio de bagagem e outros imprevistos relacionados à sua viagem. Já o seguro médico de viagem se concentra principalmente no atendimento médico durante sua estadia no exterior, cobrindo despesas médicas, hospitalização e repatriação.",
          },
          item3: {
            question:
              "Quais são os benefícios de contratar um seguro viagem internacional?",
            answer:
              "O seguro de viagem internacional oferece proteção mundial. Isso significa que você estará coberto em caso de doença ou lesão durante sua viagem ao exterior, além de receber assistência em caso de perda de bagagem, atraso de voos ou outras eventualidades que possam afetar sua experiência de viagem. Isso é muito importante, pois os custos desses imprevistos no exterior costumam ser muito caros. Com o seguro de viagem internacional, você pode ter certeza de que está coberto.",
          },
          item4: {
            question: "Como posso obter seguro viagem com a Assist 365?",
            answer:
              "Obter seguro viagem com a ASSIST 365 é rápido e fácil. Você só precisa entrar em nosso site, selecionar seu destino e as datas de sua viagem, e você terá diferentes opções de cobertura. Você pode escolher o plano que melhor se adapta às suas necessidades e fazer a compra on-line de forma segura e confiável.",
          },
          item5: {
            question:
              "Obrigatório contratar um seguro viagem para viajar a partir do Brasil?",
            answer:
              "Embora não seja obrigatório para todos os destinos, é altamente recomendável fazer um seguro de viagem quando estiver viajando da Argentina. Isso lhe dará proteção e assistência médica em caso de emergências durante sua viagem, evitando despesas imprevistas e garantindo sua tranquilidade.",
          },
        },
        landing: {
          title: "Informações úteis para sua próxima aventura",
          dropline:
            "Encontre informações e recomendações essenciais para viajar sem complicações",
          btnLabel: "Saiba mais",
        },
        mailingList: {
          title: "Fique por dentro das nossas ofertas primeiro!",
          dropline:
            "Receba no seu e-mail as melhores promoções e dicas para sua próxima viagem",
          inputPlaceholder: "Insira seu e-mail",
          btnLabel: "Inscrever-me",
          errorInput: "Insira seu e-mail",
          modal: {
            success: {
              title: "Pronto! Você já está inscrito em nossas ofertas",
              dropline: "Você receberá as melhores promoções no seu e-mail.",
            },
            failed: {
              title: "Não conseguimos processar sua inscrição",
              dropline:
                "Tente novamente, verificando se o e-mail está correto.",
              btnLabel: "Voltar",
            },
          },
        },
        blogEntries: {
          title: "Guias e dicas para viajantes",
          content:
            "Explore nosso blog para descobrir destinos e se preparar melhor para cada aventura.",
          btnLabel: "Ir ao blog",
          blog1: {
            title: "Última postagem no blog",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
          blog2: {
            title: "Entrada do blog 2",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
          blog3: {
            title: "Entrada del blog 3",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
        },
        preFooterBanner: {
          btnLabel: "Cote sua viagem",
          text: "Na sua viagem, <strong>ao seu lado.</strong>",
        },
      },
    },
    es: {
      translations: {
        feature1: {
          title: "En tu viaje, <strong>a tu lado.</strong>",
          item1:
            "Cubrimos tus <strong>necesidades médicas</strong> y también <strong>otros imprevistos</strong> que puedan afectar tu experiencia de viaje.",
          item2:
            "Te ofrecemos protección <strong>en todo el mundo</strong>, evitando costos elevados en el exterior.",
          item3:
            "Con nuestra asistencia al viajero, aseguras <strong>protección, ahorro y tranquilidad</strong> en cada etapa de tu viaje.",
        },
        feature2: {
          title: "Te acompañamos para que viajes seguro",
          item1: "Asistencia médica",
          item2: "Enfermedades preexistentes",
          item3: "Pérdida de equipaje",
          item4: "Medicamentos",
          item5: "Médico online 24hs",
          item6: "Cobertura mundial",
          item7: "Odontología",
          item8: "Internaciones",
          infoText: "¡Y mucho más, según el plan que te convenga!",
          infoText2: "Nuestros planes se ajustan a la medida de tu viaje.",
          btnLabel: "Cotiza y conoce los planes",
        },
        feature3: {
          title: "Aseguramos tus ganas de pasarla bien",
          dropline:
            "Estamos con vos para disfrutar y para acompañarte cuando sucede un imprevisto",
          item1:
            "Contrata Assist 365 y comienza tu viaje con tranquilidad, estamos listos para acompañarte.",
          item2:
            "Si surge algún inconveniente, nuestra central de emergencias te brindará orientación según tus necesidades.",
          item3: "Sigue disfrutando sin preocupaciones, estamos a tu lado.",
          btnLabel: "Cotiza tu viaje ahora",
        },
        feature4: {
          title: "Si viajas seguido, tenemos el plan perfecto",
          infoText:
            "Viajes ilimitados durante todo un año, hasta 30, 60 o 90 días por viaje.",
          btnLabel: "Cotiza y conoce multitrip",
        },
        feature5: {
          title: "Eleva tu experiencia",
          dropline:
            "Lleva tu cobertura al siguiente nivel con opciones adicionales que se ajustan a tus necesidades",
          card1: {
            title: "Tecnología protegida",
            content:
              "Cobertura para cámaras fotográficas, filmadoras, teléfonos inteligentes, tablets y computadoras.",
          },
          card2: {
            title: "Cobertura en embarazo",
            content:
              "Para futuras mamás, cobertura hasta las 32 semanas de gestación, entre los 19 y los 45 años.",
          },
          card3: {
            title: "Rotura de equipaje",
            content:
              "Cobertura en caso de daños en el exterior del equipaje o violación de cerraduras.",
          },
          card4: {
            title: "Asistencia para mascotas",
            content:
              "Para la salud de tus mascotas, cobertura por accidentes o enfermedades no preexistentes.",
          },
          btnLabel: "Cotiza tu viaje ahora",
        },
        paymentMethods: {
          title:
            "Paga con tarjeta de crédito, débito, Mercado Pago, Paypal, transferencia bancaria o efectivo.",
          infoText: "¿Tienes dudas sobre los métodos de pago?",
          linkText: "Visita las preguntas frecuentes",
          btnLabel: "Cotiza tu viaje",
        },
        faqs: {
          title: "Todo lo que necesitas saber para viajar sin preocupaciones ",
          ctaFaqs: "Leer otras preguntas frecuentes",
          item1: {
            question: "¿Qué es un seguro de viaje y para qué sirve?",
            answer:
              "Un seguro de viaje es un servicio que brinda asistencia general y soporte médico en caso de emergencias durante tu viaje. Con ASSIST 365 obtendrás protección médica, repatriación sanitaria, asistencia legal, cobertura por pérdida de equipaje, entre varios otros servicios esenciales para garantizar tu tranquilidad mientras viajas.",
          },
          item2: {
            question:
              "¿Cuál es la diferencia entre un seguro de viaje y un seguro médico para viajar?",
            answer:
              "Un seguro de viaje proporciona una amplia cobertura que incluye prestaciones médicas, asistencia por vuelo demorado, pérdida de equipaje y otros imprevistos relacionados con tu viaje. Mientras que un seguro médico para viajar se enfoca principalmente en la atención médica durante tu estadía en el extranjero, cubriendo gastos médicos, hospitalización y repatriación sanitaria.",
          },
          item3: {
            question:
              "¿Cuáles son los beneficios de contratar un seguro de viaje internacional?",
            answer:
              "Un seguro de viaje internacional te brinda protección en todo el mundo. Esto significa que estarás cubierto en caso de enfermedad o lesión durante tu viaje al extranjero, además de recibir asistencia en caso de pérdida de equipaje, retraso de vuelos u otras eventualidades que puedan afectar tu experiencia de viaje. Esto es muy importante, ya que los costos por estos imprevistos en el exterior, suelen ser muy costos. Con un seguro de viaje internacional, te aseguras la tranquilidad de estar cubierto.",
          },
          item4: {
            question:
              "¿Cómo puedo obtener asistencia al viajero con Assist 365?",
            answer:
              "Obtener asistencia al viajero con ASSIST 365 es rápido y sencillo. Solo necesitas ingresar a nuestro sitio web, seleccionar tu destino y las fechas de tu viaje, y obtendrás diferentes opciones de cobertura. Puedes elegir el plan que mejor se adapte a tus necesidades y realizar la compra online de forma segura y confiable.",
          },
          item5: {
            question:
              "¿Es obligatorio contratar un seguro de viaje para viajar desde Argentina?",
            answer:
              "Aunque no es obligatorio para todos los destinos, se recomienda encarecidamente contratar un seguro de viaje al viajar desde tu país de residencia hacia otro. Esto te brindará protección y asistencia médica en caso de emergencias durante tu viaje, evitando gastos imprevistos y garantizando tu tranquilidad.",
          },
        },
        landing: {
          title: "Información útil para tu próxima aventura",
          dropline:
            "Encuentra datos y recomendaciones esenciales para viajar sin complicaciones.",
          btnLabel: "Conocer más",
          landing1: {
            title: "Seguro de viaje en Europa",
            content:
              "Descubrí nuestras opciones de seguro de viaje en Europa para protegerte de imprevistos médicos y emergencias.",
          },
          landing2: {
            title: "Seguro de viaje para Brasil",
            content:
              "Descubrí nuestras opciones de seguro de viaje en Europa para protegerte de imprevistos médicos y emergencias.",
          },
          landing3: {
            title: "Requisitos para viajar a Chile",
            content:
              "Descubrí nuestras opciones de seguro de viaje en Europa para protegerte de imprevistos médicos y emergencias.",
          },
        },
        mailingList: {
          title: "¡Entérate primero de nuestras ofertas!",
          dropline:
            "Recibe en tu correo las mejores promociones y consejos para tu próximo viaje",
          inputPlaceholder: "Ingresa tu correo electrónico",
          btnLabel: "Suscribirme",
          errorInput: "Ingresa tu correo electrónico",
          modal: {
            success: {
              title: "¡Listo! Ya te suscribimos a nuestras ofertas",
              dropline:
                "Vas a recibir las mejores promociones en tu correo electrónico",
              btnLabel: "Volver",
            },
            failed: {
              title: "No pudimos gestionar tu suscripción",
              dropline:
                "Vuelve a intentarlo verificando que el mail sea correcto",
              btnLabel: "Volver",
            },
          },
        },
        blogEntries: {
          title: "Guías y consejos para viajeros",
          content:
            "Explora nuestro blog para descubrir destinos y prepararte mejor para cada aventura.",
          btnLabel: "Ir al blog",
          blog1: {
            title: "Última entrada del blog",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
          blog2: {
            title: "Entrada del blog 2",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
          blog3: {
            title: "Entrada del blog 3",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
        },
        preFooterBanner: {
          btnLabel: "Cotizá tu asistencia",
          text: "En tu viaje, <strong>a tu lado.</strong>",
        },
      },
    },
    "es-AR": {
      translations: {
        feature1: {
          title: "En tu viaje, <strong>a tu lado.</strong>",
          item1:
            "Cubrimos tus <strong>necesidades médicas</strong> y también <strong>otros imprevistos</strong> que puedan afectar tu experiencia de viaje.",
          item2:
            "Te ofrecemos protección <strong>en todo el mundo</strong>, evitando costos elevados en el exterior. ",
          item3:
            "Con nuestra asistencia al viajero, asegurás <strong>protección, ahorro y tranquilidad</strong> en cada etapa de tu viaje.",
        },
        feature2: {
          title: "Te acompañamos para que viajes seguro",
          item1: "Asistencia médica",
          item2: "Enfermedades preexistentes",
          item3: "Pérdida de equipaje",
          item4: "Medicamentos",
          item5: "Médico online 24hs",
          item6: "Cobertura mundial",
          item7: "Odontología",
          item8: "Internaciones",
          infoText: "¡Y mucho más, según el plan que te convenga!",
          infoText2: "Nuestros planes se ajustan a la medida de tu viaje.",
          btnLabel: "Cotizá y conocé los planes",
        },
        feature3: {
          title: "Aseguramos tus ganas de pasarla bien",
          dropline:
            "Estamos con vos para disfrutar y para acompañarte cuando sucede un imprevisto",
          item1:
            "Contratá Assist 365 y comenzá tu viaje con tranquilidad, estamos listos para acompañarte.",
          item2:
            "Si surge algún inconveniente, nuestra central de emergencias te brindará orientación según tus necesidades.",
          item3: "Seguí disfrutando sin preocupaciones, estamos a tu lado.",
          btnLabel: "Cotizá tu viaje ahora",
        },
        feature4: {
          title: "Si viajás seguido, tenemos el plan perfecto",
          infoText:
            "Viajes ilimitados durante todo un año, hasta 30, 60 o 90 días por viaje.",
          btnLabel: "Cotizá y conocé multitrip",
        },
        feature5: {
          title: "Elevá tu experiencia",
          dropline:
            "Llevá tu cobertura al siguiente nivel con opciones adicionales que se ajustan a tus necesidades",
          card1: {
            title: "Tecnología protegida",
            content:
              "Cobertura para cámaras fotográficas, filmadoras, teléfonos inteligentes, tablets y computadoras.",
          },
          card2: {
            title: "Cobertura en embarazo",
            content:
              "Para futuras mamás, cobertura hasta las 32 semanas de gestación, entre los 19 y los 45 años.",
          },
          card3: {
            title: "Rotura de equipaje",
            content:
              "Cobertura en caso de daños en el exterior del equipaje o violación de cerraduras.",
          },
          card4: {
            title: "Asistencia para mascotas",
            content:
              "Para la salud de tus mascotas, cobertura por accidentes o enfermedades no preexistentes.",
          },
          btnLabel: "Cotizá tu viaje ahora",
        },
        paymentMethods: {
          title:
            "Pagá con tarjeta de crédito, débito, Mercado Pago o transferencia bancaria.",
          infoText: "¿Tenés dudas sobre los métodos de pago?",
          linkText: "Visitá las preguntas frecuentes",
          btnLabel: "Cotizá tu viaje",
        },
        faqs: {
          title: "Todo lo que necesitás saber para viajar sin preocupaciones",
          ctaFaqs: "Leer otras preguntas frecuentes",
          item1: {
            question: "¿Qué es la asistencia al viajero?",
            answer:
              "La asistencia al viajero es un servicio que brinda cobertura y soporte médico en caso de emergencias durante tu viaje. Con ASSIST 365 obtendrás protección médica, repatriación sanitaria, asistencia legal, cobertura por pérdida de equipaje, entre varios otros servicios esenciales para garantizar tu tranquilidad mientras viajas.",
          },
          item2: {
            question:
              "¿Cuál es la diferencia entre un seguro de viaje y un seguro médico para viajar?",
            answer:
              "Un seguro de viaje proporciona una amplia cobertura que incluye prestaciones médicas, asistencia por vuelo demorado, pérdida de equipaje y otros imprevistos relacionados con tu viaje. Mientras que un seguro médico para viajar se enfoca principalmente en la atención médica durante tu estadía en el extranjero, cubriendo gastos médicos, hospitalización y repatriación sanitaria.",
          },
          item3: {
            question:
              "¿Cuáles son los beneficios de contratar un seguro de viaje internacional?",
            answer:
              "Un seguro de viaje internacional te brinda protección en todo el mundo. Esto significa que estarás cubierto en caso de enfermedad o lesión durante tu viaje al extranjero, además de recibir asistencia en caso de pérdida de equipaje, retraso de vuelos u otras eventualidades que puedan afectar tu experiencia de viaje. Esto es muy importante, ya que los costos por estos imprevistos en el exterior, suelen ser muy costos. Con un seguro de viaje internacional, te asegurás la tranquilidad de estar cubierto.",
          },
          item4: {
            question:
              "¿Cómo puedo obtener asistencia al viajero con Assist 365?",
            answer:
              "Obtener asistencia al viajero con ASSIST 365 es rápido y sencillo. Sólo necesitás ingresar a nuestro sitio web, seleccionar tu destino y las fechas de tu viaje, y obtendrás diferentes opciones de cobertura. Podés elegir el plan que mejor se adapte a tus necesidades y realizar la compra online de forma segura y confiable.",
          },
          item5: {
            question:
              "¿Es obligatorio contratar un seguro de viaje para viajar desde Argentina?",
            answer:
              "Aunque no es obligatorio para todos los destinos, se recomienda encarecidamente contratar un seguro de viaje al viajar desde Argentina. Esto te brindará protección y asistencia médica en caso de emergencias durante tu viaje, evitando gastos imprevistos y garantizando tu tranquilidad.",
          },
        },
        landing: {
          title: "Información útil para tu próxima aventura",
          dropline:
            "Encontrá datos y recomendaciones esenciales para viajar sin complicaciones.",
          btnLabel: "Conocer más",
          landing1: {
            title: "Seguro de viaje en Europa",
            content:
              "Descubrí nuestras opciones de seguro de viaje en Europa para protegerte de imprevistos médicos y emergencias.",
          },
          landing2: {
            title: "Seguro de viaje para Brasil",
            content:
              "Descubrí nuestras opciones de seguro de viaje en Europa para protegerte de imprevistos médicos y emergencias.",
          },
          landing3: {
            title: "Requisitos para viajar a Chile",
            content:
              "Descubrí nuestras opciones de seguro de viaje en Europa para protegerte de imprevistos médicos y emergencias.",
          },
        },
        mailingList: {
          title: "¡Enterate primero de nuestras ofertas!",
          dropline:
            "Recibí en tu correo las mejores promociones y consejos para tu próximo viaje",
          inputPlaceholder: "Ingresá tu correo electrónico",
          btnLabel: "Suscribirme",
          errorInput: "Ingresá tu correo electrónico",
          modal: {
            success: {
              title: "¡Listo! Ya te suscribimos a nuestras ofertas",
              dropline:
                "Vas a recibir las mejores promociones en tu correo electrónico",
            },
            failed: {
              title: "No pudimos gestionar tu suscripción",
              dropline:
                "Volvé a intentarlo verificando que el mail sea correcto",
              btnLabel: "Volver",
            },
          },
        },
        blogEntries: {
          title: "Guías y consejos para viajeros",
          content:
            "Explorá nuestro blog para descubrir destinos y prepararte mejor para cada aventura.",
          btnLabel: "Ir al blog",
          blog1: {
            title: "Última entrada del blog",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
          blog2: {
            title: "Entrada del blog 2",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
          blog3: {
            title: "Entrada del blog 3",
            content:
              "Lorem ipsum dolor sit amet consectetur. Neque augue venenatis et risus pellentesque donec tellus vel tortor. Laoreet augue faucibus.",
          },
        },
        preFooterBanner: {
          btnLabel: "Cotizá tu asistencia",
          text: "En tu viaje, <strong>a tu lado.</strong>",
        },
      },
    },
  },
  lng: "es-AR",
  fallbackLng: "es",
  ns: ["translations"],
  defaultNS: "translations",
});
export default i18n;
